<template>
	<button class='keyboard-row-letter' :id='letter' :disabled='disabled' @click='clicked()'>{{ letter }}</button>
</template>
<script>
export default{
	name: 'letter-button',
	props: ["letter", "gameOver", "twoPlayers"],
	template: "<button class='keyboard-row-letter' :id='letter' :disabled='disabled' @click='clicked()'>{{ letter }}</button>",
	data: function() {
		return {
			disabled: false
		};
	},
	// disable button on click, and send 'check' event to run check() in main vue instance
	methods: {
		clicked: function() {
			this.disabled = true;
			this.$emit("check");
		}
	},
	watch: {
		// disable all buttons on game over; re-enable all buttons on restart
		gameOver: function(newValue) {
			this.disabled = newValue;
		},
		// re-enable all buttons when a new two-player game is started
		twoPlayers: function(newValue) {
			this.disabled = false;
		}
	}
};	
</script>